import Medusa from '@adoratorio/medusa';

export default {
  id: 'lazyLoading',
  nodes: [],
  container: document.getElementById('app'),
  threshold: 0,
  offsets: '0px 0px 300px 0px',
  emitGlobal: false,
  callback: ({ target }) => {
    const url = target.children[0].getAttribute('data-src');
    target.children[0].setAttribute('src', url);
    target.removeAttribute('data-src');
  },
  mode: Medusa.MODE.ONCE,
};
